export default __webpack_public_path__ + "static/media/1.efd396e7.mp3";